import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/shared/models/user.model';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { UserListService } from './user-list.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserCreateModalComponent } from '../user-create-modal/user-create-modal.component';
import { Response } from 'src/app/shared/models/response.model';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  users: User[];
  modalOptions: NgbModalOptions;
  
  paginationOffset: number;
  paginationLimit : number;
  paginationTotal : number;
  paginationMaxPageSize: number;
  searchFilter: string;

  private getAllSubscription: Subscription = null;
  private deleteSubscription: Subscription = null;
  private createSubscription: Subscription = null;
  private editSubscription: Subscription = null;

  constructor(private userListService: UserListService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.paginationOffset      = 1;
    this.paginationLimit       = 10;
    this.paginationTotal       = 0;
    this.paginationMaxPageSize = 5;
    this.searchFilter          = '';
    
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.getUsers();
  }

  ngOnDestroy(): void {
    if (this.getAllSubscription !== null) { this.getAllSubscription.unsubscribe(); }
    if (this.deleteSubscription !== null) { this.deleteSubscription.unsubscribe(); }
    if (this.createSubscription !== null) { this.createSubscription.unsubscribe(); }
    if (this.editSubscription   !== null) { this.editSubscription.unsubscribe(); }
  }

  /**
   * Get filtered user list
   */
  getUsers() {
    this.spinner.show();

    this.getAllSubscription = this.userListService.resolveUsers(this.searchFilter, this.paginationOffset, this.paginationLimit).subscribe((result: Response) => {
      this.users            = result.items;
      this.paginationTotal  = result.total;

      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error);
      console.error(error);
    });
  }

  /**
   *
   */
  onCreate(): void {
    const modalRef = this.modalService.open(UserCreateModalComponent, this.modalOptions);
    modalRef.result.then((data) => {
      // Se crea el registro
      this.spinner.show();
      this.createSubscription = this.userListService.create(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getUsers();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in user create', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param rol
   */
  onEdit(user: User): void {
    const modalRef = this.modalService.open(UserCreateModalComponent, this.modalOptions);
    modalRef.componentInstance.user = user;
    modalRef.result.then((data) => {
      // Se modifica el registro
      this.spinner.show();
      this.editSubscription = this.userListService.update(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getUsers();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in user modify', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param id
   * @param index
   */
  onDelete(id: number, index: number): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        // Se elimina el registro
        this.spinner.show();
        this.deleteSubscription = this.userListService.delete(id).subscribe(r => {
          this.users.splice(index, 1);
          this.spinner.hide();
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        },
        (error) => {
          this.spinner.hide();
          this.toastr.error(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

  /**
   * 
   * @param term 
   */
  onSearch(term: string) {
    this.searchFilter = term;
    this.getUsers();
  }

  /**
   * 
   */
  onPageChange() {
    this.getUsers();
  }
}
